import { ACCENT, BORDER, FONT_ACCENT, FONT_MONO, MUTED, SURFACE, TEXT_PRIMARY } from '../../tokens';

interface StatBoxProps {
  label: string;
  value: string;
  /** Tints the box in the accent colour. */
  accent?: boolean;
  /** Adds a glow, used to highlight the stat an InfoToggle is explaining. */
  glow?: boolean;
}

/** A single headline figure in the calculator's results row. */
export function StatBox({ label, value, accent = false, glow = false }: StatBoxProps) {
  return (
    <div
      style={{
        background: accent ? 'rgba(255,107,0,0.08)' : SURFACE,
        border: `1px solid ${glow ? 'rgba(255,107,0,0.6)' : accent ? 'rgba(255,107,0,0.3)' : BORDER}`,
        borderRadius: 18,
        padding: '24px 22px',
        boxShadow: glow ? '0 0 24px rgba(255,107,0,0.12)' : 'none',
        transition: 'border-color 0.3s, box-shadow 0.3s',
      }}
    >
      <div
        style={{
          fontFamily: FONT_MONO,
          fontSize: '0.62rem',
          color: accent ? ACCENT : MUTED,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          marginBottom: 8,
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontFamily: FONT_ACCENT,
          fontStyle: 'italic',
          fontSize: 'clamp(1.8rem,3vw,2.6rem)',
          fontWeight: 400,
          lineHeight: 1,
          color: TEXT_PRIMARY,
        }}
      >
        {value}
      </div>
    </div>
  );
}
